import React from "react";
import Hero from "@/pages/home/Hero";
import Problem from "@/pages/home/Problem";
import TestGovernProve from "@/pages/home/TestGovernProve";
import EvidenceCore from "@/pages/home/EvidenceCore";
import GraphSection from "@/pages/home/GraphSection";
import Proof from "@/pages/home/Proof";
import NextState from "@/pages/home/NextState";
import Audience from "@/pages/home/Audience";
import Differentiation from "@/pages/home/Differentiation";
import Marquee from "@/components/Marquee";
import { CTASection } from "@/components/shared";

export default function Home() {
  return (
    <>
      {/* 01 HERO */}
      <Hero />
      <Marquee items={["ISO/IEC 42001", "EU AI Act", "NIST AI RMF", "OWASP LLM", "UAE PDPL"]} />
      {/* 02 THE TRUST GAP */}
      <Problem />
      {/* 03 TEST → GOVERN → PROVE */}
      <TestGovernProve />
      {/* 04 MEIRA TRUST ARCHITECTURE (Evidence Core + standards perspectives) */}
      <EvidenceCore />
      {/* 05 TRUST GRAPH */}
      <GraphSection />
      {/* 06 PROOF / TRUST PASSPORT / CERTIFICATE */}
      <Proof />
      {/* 07 CONTINUOUS + AGENTIC */}
      <NextState />
      {/* 08 AUDIENCE */}
      <Audience />
      {/* 09 DIFFERENTIATION */}
      <Differentiation />
      {/* 10 FINAL CTA */}
      <CTASection />
    </>
  );
}
